<script lang="ts">
	import {
		CarInfo,
		CarPickup,
		CarSearchOutline,
		Check,
		CheckCircleOutline,
		CircleOutline,
		CloseIcon,
		Factory,
		InformationOutline,
		MinusCircle,
		OpenInNew,
		TriangleOutline,
		WeightGram,
	} from '../icons';
	import { Color } from '../scripts/color';
	import { is_2nd_store, jumpToScripLink } from '../scripts/util';

	const add_prefix = is_2nd_store ? 'alt-' : '';

	export let analysis_result: type_service_search_result;
	export const vin: string = '';
</script>

<ul class="result-messages">
	{#each analysis_result.messages as m}
		<li class="red">{m}</li>
	{/each}
</ul>
{#if analysis_result.analysis && analysis_result.analysis.vehicle}
	{@const vehicle_info = analysis_result.analysis.vehicle}
	{@const vehicle_name = analysis_result.analysis.vehicle.vehicle_name}
	<div class="panel">
		<div class="panel-body p-2">
			<div class="vehicle-info">
				<span class="me-4 border-chip {add_prefix}sea"> <CarSearchOutline size="1.2em" /> 車種</span>
				<p class="fl m-0">
					{#if vehicle_info.model_year}
						<span>{vehicle_info.model_year}年&nbsp;</span>
					{/if}
					{#if !is_2nd_store && vehicle_info.maker}
						<span>{vehicle_info.maker}&nbsp;</span>
					{/if}
					{#if vehicle_name}
						<span>{vehicle_name}&nbsp;</span>
					{/if}
					{#if vehicle_info.displacement}
						<span>{vehicle_info.displacement}&nbsp;</span>
					{/if}
					{#if is_2nd_store && vehicle_info.load_capacity}
						<span>{vehicle_info.load_capacity}&nbsp;</span>
					{/if}
					{#if is_2nd_store && vehicle_info.drive_system}
						<span>{vehicle_info.drive_system}&nbsp;</span>
					{/if}
				</p>
			</div>
		</div>
	</div>
	{#if !is_2nd_store && analysis_result.messages.length === 0}
		<div class="float-check-sign">
			<CheckCircleOutline size="2.3em" title="デコード成功！！" />
		</div>
	{/if}
{/if}

<style lang="scss" scoped>
	@use '../sass/color.scss' as color;
	.panel {
		.panel-body {
			overflow-y: unset;
			.vehicle-info {
				display: flex;
				flex-wrap: wrap;
				gap: 0.3rem;
				p {
					font-weight: bold;
				}
				.tile {
					flex: auto;
					min-width: 140px;
				}
				.chip {
					border: solid 1px color.$sea;
				}
				.btn-scrip {
					border-color: #444;
					color: #444;
				}
			}

			@media (max-width: 1000px) {
				padding: 0;
			}
		}
	}
	.float-check-sign {
		position: absolute;
		bottom: 0.4%;
		right: 0.9%;
		color: color.$teal;
		background-color: transparent;
	}
</style>
